// Entry SPA GS Gestion — AuthProvider MSAL + ROLE_MAPPINGS (3 groupes Azure AD).
// NB Systeme C : les ROLE_MAPPINGS cote SPA servent l'AFFICHAGE/garde client ; l'AUTORISATION
// reelle est cote serveur (requireRole sur ug.UserCompanyBcRoles, bc_key GEST). Pas de localStorage.
//
// FIDELE A L'API REELLE (KW-024) : calque le SPA pilote admin/ug/inv (qui compile). AuthProvider
// prend roleMappings/defaultRole/appKey ; le QueryClient vient de createGsQueryClient
// (@gs/api-client, retry 401-aware) ; ToastProvider + GsLocaleProvider en tete.
import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { QueryClientProvider } from '@tanstack/react-query';
import { AuthProvider, GsRole } from '@gs/auth';
import { ToastProvider } from '@gs/ui';
import { GsLocaleProvider } from '@gs/i18n';
import { initTelemetry } from '@gs/telemetry';
import { createGsQueryClient } from '@gs/api-client';
import App from './App';
import PulseSurveyPage from './pages/sondage/PulseSurveyPage';
// i18n (MASTER-INTEGRATION-GESTION-FRAG0) — initialise i18next AVANT le render.
import './i18n';
// Inter self-hostee (@fontsource-variable/inter) — JAMAIS Google Fonts CDN.
import '@fontsource-variable/inter';
import './index.css';

initTelemetry({
  connectionString: import.meta.env.VITE_APPINSIGHTS_CONNECTION_STRING ?? '',
  appKey: 'gest',
  gitSha: import.meta.env.VITE_GS_GIT_SHA,
});

// Groupes Azure AD workforce GS (affichage/garde client). L'autorite reelle = ug.UserCompanyBcRoles cote serveur.
const ROLE_MAPPINGS = [
  { groupId: '7a9bf9f7-dde9-44ff-86c1-deee829462c4', role: GsRole.ADMIN },
  { groupId: 'e1594515-5d26-4b84-b14c-30f69d7d3ae6', role: GsRole.GESTIONNAIRE },
  { groupId: '8dd154cd-c43e-4fd8-aa4f-50f385d94486', role: GsRole.UTILISATEUR },
];

const queryClient = createGsQueryClient();

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    {/* GsLocaleProvider AU-DESSUS de tout l'UI (login inclus) : fournit
        { locale, setLocale } au selecteur Langue de GsUserMenu. */}
    <GsLocaleProvider>
      <ToastProvider>
        <QueryClientProvider client={queryClient}>
          <AuthProvider roleMappings={ROLE_MAPPINGS} defaultRole={GsRole.UTILISATEUR} appKey="gest">
            <BrowserRouter>
              {/* PULSE-SUBMIT (P-PS-4) : /sondage est la SEULE route PUBLIQUE du
                  SPA — le lien tokenise des courriels AD-G y atterrit SANS login.
                  Le branchement se fait ICI, AVANT le shell App : App (et sa
                  garde GsLoginScreen + AccessGateScreen) reste INCHANGE pour
                  toutes les autres routes — aucune garde affaiblie. AuthProvider
                  au-dessus est inerte sur cette page (ssoSilent en arriere-plan,
                  jamais de redirect sans interaction). */}
              <Routes>
                <Route path="/sondage" element={<PulseSurveyPage />} />
                <Route path="*" element={<App />} />
              </Routes>
            </BrowserRouter>
          </AuthProvider>
        </QueryClientProvider>
      </ToastProvider>
    </GsLocaleProvider>
  </React.StrictMode>,
);
